"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentGlobals = {
    ignoreResize: false
};
exports.ComponentGlobals = ComponentGlobals;
